import { css } from '@emotion/react';

import { colors } from 'src/constants/variables';

export const wrapperCustomBackgroundStyles = css`
    padding-right: 32px;
    background-color: ${colors.background};
`;
